const schools = [
    {
        area: "",
        institution_code: "123456",
        name: "לא משויך"
    },
    {
        area: "שדרות",
        institution_code: "111000",
        name: "מרכז למידה ניצן"
    }
]

export default schools